export default __webpack_public_path__ + "static/media/HOTEL_TEXT_NO_NEXT.0e28cfd3.png";